import React, { useState, ReactNode } from 'react';
import { Collapse } from 'reactstrap';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpContainer, WpContainerHeader, WpContainerBody } from 'Wpds/components/container';
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import Switcher from 'Dashboard/Switcher/Switcher';

// Styles
import './AssistantsManagerSettingsPanel.scss';

type Props = {
  index: number;
  isActive: boolean;
  title: string;
  shortDescription: string;
  children: ReactNode;
  activityInfo?: string;
  onActiveChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onCancelClick: (event: React.MouseEvent) => void;
  onSubmitClick: (event: React.MouseEvent<HTMLInputElement>) => void;
  formChanged: boolean;
};

function AssistantsManagerSettingsPanel({
  index,
  isActive,
  title,
  shortDescription,
  children,
  onActiveChange,
  onCancelClick,
  onSubmitClick,
  formChanged,
}: Props) {
  const [isExpanded, setIsExpanded] = useState(false);
  const handleExpandToggle = () => setIsExpanded(!isExpanded);

  const handleCancelClick = event => {
    handleExpandToggle();
    onCancelClick(event);
  };

  const baseClassName = 'AssistantsManagerSettingsPanel';

  return (
    <WpContainer className={baseClassName}>
      <WpContainerHeader>
        <div className={`${baseClassName}__header`}>
          <h5 className={`${baseClassName}__header__title`}>{title}</h5>
          <Switcher
            isOneSideLabel
            id={`${index}-assistants-manager-settings-switcher`}
            checked={isActive}
            onChange={onActiveChange}
          />
        </div>
      </WpContainerHeader>
      <WpContainerBody>
        <div className={`${baseClassName}__description`}>{shortDescription}</div>
        <WpButton variant={isExpanded ? 'tertiary' : 'primary'} onClick={handleExpandToggle}>
          <WpIcon name={isExpanded ? 'angle-down' : 'angle-right'} />
          Edit settings
        </WpButton>
        <Collapse isOpen={isExpanded}>
          <div className={`${baseClassName}__edit-panel`}>
            {children}

            <WpButtonGroup>
              <WpButton onClick={onSubmitClick} disabled={!formChanged}>
                Save
              </WpButton>
              <WpButton variant="tertiary" onClick={handleCancelClick} disabled={!formChanged}>
                Cancel
              </WpButton>
            </WpButtonGroup>
          </div>
        </Collapse>
      </WpContainerBody>
    </WpContainer>
  );
}

export default AssistantsManagerSettingsPanel;
